// toyota theme
const toyota = {
    brand: 'toyota',
    font: 'UniversLTStd',
    color: '#EB0A1E',
    color30: 'rgb(235, 10, 30, 0.3)',
    logo: 'tfs-logo.jpg',
    footerTxt: 'Toyota Financial Services',
    mainBtn: {
        txt: '#FFFFFF',
        bg: '#EB0A1E',
    },
    outlineBtn: {
        border: '#EB0A1E',
        txt: '#EB0A1E',
        bg: '#FFFFFF',
    },
    backBtn: {
        txt: '#FFFFFF',
        bg: '#AAAAAA',
    },
    financialService: 'Toyota Financial Services',
};

// lexus theme
const lexus = {
    brand: 'lexus',
    font: 'NobelRegular',
    color: '#000000',
    color30: 'rgb(0, 0, 0, 0.3)',
    logo: 'LexusLogo.png',
    footerTxt: 'Lexus Financial Services',
    mainBtn: {
        txt: '#FFFFFF',
        bg: '#000000',
    },
    outlineBtn: {
        border: '#B9C0C2',
        bg: '#B9C0C2',
        txt: '#FFFFFF',
    },
    backBtn: {
        txt: '#FFFFFF',
        bg: '#B9C0C2',
    },
    financialService: 'Toyota Financial Services',
};

// sgcm theme
const sgcm = {
    ...toyota,
    brand: 'sgcm',
    logo: 'sgcm-logo.svg',
    footerTxt: 'Sgcarmart Financial Services',
    financialService: 'Sgcarmart Financial Services',
};

export const profile = {
    toyota,
    lexus,
    sgcm,
};

export const TOYOTA = 'TOYOTA';
export const LEXUS = 'LEXUS';

export const MYINFO = 'MYINFO';
export const MANUAL = 'MANUAL';

export const applicantDetails = {
    source: '',
    name: {
        value: '',
        source: '',
    },
    identityNo: {
        value: '',
        source: '',
    },

    gender: {
        value: '',
        source: '',
    },
    dob: {
        value: null,
        source: '',
    },
    race: {
        value: '',
        source: '',
    },
    maritalStatus: {
        value: '',
        source: '',
    },
    nationality: {
        value: '',
        source: '',
    },
    residentialStatus: {
        value: '',
        source: '',
    },
    myInfoDate: null,
    drivingLicense: {
        status: '',
        qdl: {
            status: '',
            validity: '',
            expirydate: null,
            classes: [
                {
                    licenseClass: '',
                    issueDate: null,
                },
            ],
        },
        pdl: {
            status: '',
            validity: '',
            expirydate: null,
            classes: [
                {
                    licenseClass: '',
                },
            ],
        },
        supportingDocuments: [],
        source: '0',
    },
    contactDetails: {
        mobileNo: {
            value: '',
            source: '',
        },
        emailAddress: {
            value: '',
            source: '',
        },
    },
    residentialAddress: {
        block: '',
        street: '',
        building: '',
        unit: '',
        country: '',
        postalCode: '',
        source: '',
    },
    employment: {
        employer: {
            value: '',
            source: '',
        },
        occupation: {
            value: '',
            source: '',
        },
        assessibleIncome: {
            value: '',
            source: '',
        },
        assessmentYear: {
            value: '',
            source: '',
        },
        cpfContributions: [],
        supportingDocuments: [],
    },
};

export const INCORRECT_OTP = 'Incorrect OTP';
